<template>
  <v-card class="d-flex flex-column align-content-center">
    <!-- Información del Empleado -->
    <v-card-subtitle class="d-flex ma-0 pa-0 justify-space-between">
      <!-- Información del empleado -->
      <div class="d-flex align-self-center mx-3 my-2">
        <v-icon>mdi-account-tie</v-icon>
        <h3>{{ employeeData.nombreCompleto }} ({{ employeeData.empId }})</h3>
      </div>
      <div class="d-flex flex-row mx-4 my-2">
        <div class="d-flex align-center mr-2">
          <v-sheet
            class="legend-box mr-1"
            tile
            color="green lighten-2"
          ></v-sheet>
          <span class="legend-text">Día laborable</span>
        </div>
        <div class="d-flex align-center mr-2">
          <v-sheet
            class="legend-box mr-1 d-flex align-center"
            tile
            color="red darken-1"
          >
            <v-icon left small color="white">mdi-label</v-icon>
          </v-sheet>
          <span class="legend-text">Feriado</span>
        </div>
        <div class="d-flex align-center mr-2">
          <v-sheet
            color="red darken-1"
            height="14"
            width="6"
            class="mr-1"
            style="border-radius: 3px"
          />
          <span class="legend-text">Ausente</span>
        </div>
        <div class="d-flex align-center mr-2">
          <v-sheet
            color="yellow darken-1"
            height="14"
            width="6"
            class="mr-1"
            style="border-radius: 3px"
          />
          <span class="legend-text">Irregular</span>
        </div>
        <div class="d-flex align-center mr-2">
          <v-sheet
            color="blue darken-1"
            height="14"
            width="6"
            class="mr-1"
            style="border-radius: 3px"
          />
          <span class="legend-text">Sin Incidencias</span>
        </div>
        <div class="d-flex align-center">
          <v-sheet
            color="green darken-1"
            height="14"
            width="6"
            class="mr-1"
            style="border-radius: 3px"
          />
          <span class="legend-text">Jornada Extendida</span>
        </div>
      </div>
      <div>
        <v-btn icon @click="closeCalendar" color="black">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card-subtitle>

    <v-row class="mx-2 pb-2 pa-0 ma-0">
      <!-- Controles del Calendario y Calendario -->
      <v-col cols="9" class="ma-0 pa-0" style="border: 0.5px solid lightgrey">
        <!-- Controles del Calendario -->
        <v-toolbar flat color="primary" class="d-flex justify-center">
          <v-btn fab text color="white" @click="prevMonth">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title style="color: white">{{
            formattedMonthYear
          }}</v-toolbar-title>
          <v-btn fab text color="white" @click="nextMonth">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>

        <!-- Calendario -->
        <v-sheet class="custom-height">
          <v-calendar
            ref="calendar"
            :now="today"
            :value="calendarDate"
            color="primary"
            locale="es"
            :key="calendarKey"
          >
            <template v-slot:day="{ date, outside }">
              <v-row class="fill-height" :class="{ 'day-outside': outside }">
                <v-menu
                  v-model="menus[date]"
                  offset-x
                  :close-on-content-click="false"
                  @click:outside="handleMenuOutsideClick(date)"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-sheet
                      v-bind="attrs"
                      v-on="on"
                      :color="getDayColor(date)"
                      class="mt-n15"
                      tile
                    >
                      <v-row class="d-flex justify-center">
                        <!-- Primera fila: Chip de día festivo -->
                        <v-col cols="10">
                          <v-chip
                            v-if="getTextHoliday(date)"
                            color="red darken-1"
                            text-color="white"
                            label
                            x-small
                            class="mt-5 d-flex justify-center"
                          >
                            {{ getTextHoliday(date) }}
                          </v-chip>
                          <div else class="mt-3"></div>
                        </v-col>

                        <!-- Segunda fila: Chips generados en línea -->
                        <v-col
                          v-bind:class="{
                            'd-flex justify-center px-15': true,
                            'mt-n3': getTextHoliday(date),
                            'pt-8': !getTextHoliday(date),
                          }"
                        >
                          <!-- Rectángulo gris envolvente -->
                          <v-sheet
                            v-for="(color, index) in getLabels(date)"
                            :key="index"
                            :color="color"
                            height="14"
                            width="6"
                            class="mr-1"
                            style="border-radius: 3px"
                          />
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </template>

                  <!-- Mostrar información según los datos disponibles -->
                  <v-list>
                    <template v-if="getMappedDateInfo(date)">
                      <template>
                        <v-list-item
                          @click="showDetail('Detalle del día', date)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-calendar-today</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Detalle del Día</v-list-item-title>
                        </v-list-item>
                      </template>
                      <template>
                        <v-list-item
                          @click="showDetail('Detalle de Liquidación', date)"
                          :disabled="!getMappedDateInfo(date).liqD?.length"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-calendar-month</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Detalle de Liquidación</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                      <template>
                        <v-list-item
                          @click="
                            showDetail('Detalle de Elementos del Horario', date)
                          "
                          :disabled="!getMappedDateInfo(date).elementos?.length"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-calendar-clock</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Detalle de Elementos del Horario</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                      <template>
                        <template>
                          <v-list-item
                            @click="showDetail('Registraciones', date)"
                            :disabled="!getMappedDateInfo(date).regis?.length"
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-file-document-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title
                              >Registraciones</v-list-item-title
                            >
                          </v-list-item>
                        </template>
                        <v-list-item
                          @click="showDetail('Tardes y Retiros', date)"
                          :disabled="!getMappedDateInfo(date).tarRet?.length"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clock-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            >Tardes y Retiros</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                    </template>
                    <template v-else>
                      <v-list-item disabled>
                        <v-list-item-title
                          >No hay información disponible</v-list-item-title
                        >
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
              </v-row>
            </template>
          </v-calendar>
        </v-sheet>
      </v-col>

      <!-- Toolbar de Totales -->
      <v-col cols="3" class="ma-0 pa-0" style="border: 0.5px solid lightgrey">
        <v-toolbar flat color="primary" class="d-flex flex-column">
          <v-toolbar-title style="color: white">Totales</v-toolbar-title>
        </v-toolbar>
        <v-list dense height="525px">
          <v-list-item
            v-for="(total, index) in formattedTotals"
            :key="index"
            class="ma-0 py-0"
          >
            <v-list-item-subtitle
              >{{ total.name }}: {{ total.value }}</v-list-item-subtitle
            >
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <!-- Dialogo para mostrar detalles -->
    <v-dialog v-model="dialog" max-width="1200px" persistent>
      <v-card>
        <v-card-title class="d-flex align-center">
          <span
            ><v-icon>mdi-calendar</v-icon>
            {{ Object.keys(menus).find((date) => menus[date]) || "" }}</span
          >
          <v-spacer></v-spacer>
          <span>{{ dialogTitle }}</span>
          <v-spacer></v-spacer>
          <v-tooltip text="Cerrar" location="top">
            <template v-slot:activator="{ props }">
              <v-btn icon v-bind="props" @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <TableWithSearch
            :items="dialogData"
            :headers="dialogHeaders"
            :showAdd="false"
            :showConfig="false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from "moment";
import TableWithSearch from "../../Complement/TableWithSearch.vue";
import registrations from "../../../models/gestionEmpleados/calendar/registrations";
import elements from "../../../models/gestionEmpleados/calendar/elements";
import retiros from "../../../models/gestionEmpleados/calendar/lateAndEarlyDepartures";
import liquidations from "../../../models/gestionEmpleados/calendar/liquidation";
import detail from "../../../models/gestionEmpleados/calendar/detail";

export default {
  components: { TableWithSearch },
  name: "MonthlyRecordCard",
  data() {
    return {
      calendarKey: 0,
      dialog: false, // Controla el diálogo
      dialogTitle: "", // Título del diálogo
      dialogData: {},
      today: moment().format("YYYY-MM-DD"), // Fecha actual
      calendarDate: moment().startOf("month").format("YYYY-MM-DD"), // Fecha inicial mostrada en el calendario
      menus: {},
      activeMenu: null,
      dialogHeaders: [],
      loading: false,
      headersDay: [
        {
          text: "Fecha",
          value: "fechaTable",
          class: "primary secondary--text",
          visible: true,
          width: "110px",
        },
        {
          text: "Horario",
          value: "horario",
          class: "primary secondary--text",
          visible: true,
          width: "80px",
        },
        {
          text: "Segmento",
          value: "segmento",
          class: "primary secondary--text",
          visible: true,
          width: "80px",
        },
        {
          text: "Inicio del  día",
          value: "inicioDia",
          class: "primary secondary--text",
          visible: true,
          width: "110px",
        },
        {
          text: "Fin del dia",
          value: "finDia",
          class: "primary secondary--text",
          visible: true,
          width: "110px",
        },
        {
          text: "Es feriado",
          value: "esFeriado",
          class: "primary secondary--text",
          visible: true,
          width: "100px",
        },
        {
          text: "Presente",
          value: "stPresen",
          class: "primary secondary--text",
          visible: true,
          width: "70px",
        },
        {
          text: "Ausente ",
          value: "stAusen",
          class: "primary secondary--text",
          visible: true,
          width: "70px",
        },
        {
          text: "Inconcistencia",
          value: "stIncon",
          class: "primary secondary--text",
          visible: true,
          width: "70px",
        },
        {
          text: "Caidas",
          value: "stCaidas",
          class: "primary secondary--text",
          visible: true,
          width: "70px",
        },
        {
          text: "Tarde ",
          value: "stTarde",
          class: "primary secondary--text",
          visible: true,
          width: "70px",
        },
        {
          text: "Retant",
          value: "stRetant",
          class: "primary secondary--text",
          visible: true,
          width: "100px",
        },
        {
          text: "Lic Dias",
          value: "stLicDias",
          class: "primary secondary--text",
          visible: true,
          width: "100px",
        },
        {
          text: "Lic Horas",
          value: "stLicHoras",
          class: "primary secondary--text",
          visible: true,
          width: "70px",
        },
        {
          text: "Extras",
          value: "stExtras",
          class: "primary secondary--text",
          visible: true,
          width: "70px",
        },
        {
          text: "Hs Laborables",
          value: "horLabSum",
          class: "primary secondary--text",
          visible: true,
          width: "70px",
        },
        {
          text: "Hs Trabajadas ",
          value: "horTrabSum",
          class: "primary secondary--text",
          visible: true,
          width: "70px",
        },
      ],
      headersLiqD: [
        {
          text: "Liquidación",
          value: "liq",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Concepto",
          value: "concepto",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Centro de costo",
          value: "csCosto",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Cant Liquidada",
          value: "cantLiq",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Cant Autorizada",
          value: "cantAut",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Cant No Autorizada",
          value: "cantNoAut",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Cant Cuenta Corriente",
          value: "cantCC",
          class: "primary secondary--text",
          visible: true,
        },
      ],
      headersElements: [
        {
          text: "Segmento",
          value: "segmento",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Elemento",
          value: "elemento",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "cDesde",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Hasta",
          value: "cHasta",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Concepto",
          value: "concepto",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Aplica feriados",
          value: "aplFeriados",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "resto",
          value: "resto",
          class: "primary secondary--text",
          visible: true,
        },
      ],
      headersRegis: [
        {
          text: "Entrada",
          value: "ent",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Salida",
          value: "sal",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Concepto",
          value: "concepto",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Hasta",
          value: "csCosto",
          class: "primary secondary--text",
          visible: true,
        },
      ],

      headersTarRet: [
        {
          text: "Elemento",
          value: "elemento",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Cantidad",
          value: "cantidad",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Tarde / Retiro Anticipado",
          value: "tarRetAnt",
          class: "primary secondary--text",
          visible: true,
        },
      ],
    };
  },
  computed: {
    formattedMonthYear() {
      return moment(this.calendarDate).locale("es").format("MMMM YYYY"); // Mes y año en español
    },
    employeeData() {
      const montlyTab = this.$store.state.employees.montlyTab;
      return montlyTab ? montlyTab : {}; // Devuelve un objeto vacío si no está definido.
    },
    employeeMonthTotalHs() {
      const totales = this.$store.state.employees.montlyTab.totales;
      return totales ? totales : [];
    },
    employeeDetails() {
      const detalles = this.$store.state.employees.montlyTab?.detalles;
      return detalles ? detalles : []; // Devuelve un arreglo vacío si no está definido.
    },
    formattedTotals() {
      return Object.entries(this.employeeMonthTotalHs).map(([key, value]) => {
        return {
          name: this.$t(`calendar.labels.${key}`), // Obtiene la traducción desde i18n
          value: key.includes("horas") ? this.formatHours(value) : value, // Formatea las horas
        };
      });
    },
  },
  methods: {
    truncateText(item) {
      const maxLength = 27;

      if (item?.length > maxLength) {
        return item.substring(0, maxLength) + "...";
      }

      return item;
    },

    openDialog(date) {
      const details = this.getMappedDateInfo(date);
      this.dialogData = {
        date: moment(date).format("DD MMMM YYYY"),
        details: details,
      };
      this.dialogVisible = true;
    },
    closeCalendar() {
      this.$emit("close");
      this.calendarDate = moment().startOf("month").format("YYYY-MM-DD");
    },
    formatHours(minutes) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${hours.toString().padStart(2, "0")}:${mins
        .toString()
        .padStart(2, "0")}`;
    },
    showDetail(type, date) {
      const info = this.getMappedDateInfo(date);
      this.menus[date] = true;
      switch (type) {
        case "Detalle del día":
          this.dialogTitle = "Detalle del Día";
          this.dialogData = [info].map((item) => detail.fromJson(item));
          this.dialogHeaders = this.headersDay;
          break;
        case "Detalle de Liquidación":
          this.dialogTitle = "Detalle de Liquidación";
          this.dialogData = info.liqD.map((item) =>
            liquidations.fromJson(item)
          );
          this.dialogHeaders = this.headersLiqD;
          break;
        case "Detalle de Elementos del Horario":
          this.dialogTitle = "Detalle de Elementos del Horario";
          this.dialogData = info.elementos.map((item) =>
            elements.fromJson(item)
          );
          this.dialogHeaders = this.headersElements;
          break;
        case "Registraciones":
          this.dialogTitle = "Registraciones";
          this.dialogData = info.regis.map((item) =>
            registrations.fromJson(item)
          );
          this.dialogHeaders = this.headersRegis;
          break;
        case "Tardes y Retiros":
          this.dialogTitle = "Tardes y Retiros";
          this.dialogData = info.tarRet.map((item) => retiros.fromJson(item));
          this.dialogHeaders = this.headersTarRet;
          break;
        default:
          this.dialogTitle = "Tipo no reconocido";
          this.dialogData = { Error: "El tipo seleccionado no es válido." };
          this.dialogHeaders = [];
      }
      this.dialog = true; // Abre el diálogo
    },

    closeMenu(date) {
      this.$set(this.menus, date, true);
    },
    closeDialog() {
      this.dialog = false;
    },
    isMappedDate(date) {
      return !!this.getMappedDateInfo(date);
    },
    getMappedDateInfo(date) {
      const result =
        this.employeeDetails?.find((f) => {
          const formattedFecha = moment(f.fecha).utc().format("YYYY-MM-DD");

          return formattedFecha === date;
        }) || null;

      return result;
    },

    getDayColor(date) {
      const info = this.getMappedDateInfo(date);
      if (info) {
        return info.horLabSum > 0 ? "day-highlight-green" : "day-highlight-red";
      }
      return "transparent";
    },
    getIconColor(date) {
      const info = this.getMappedDateInfo(date);
      return info && !info.horLabSum ? "yellow" : "blue";
    },
    getTextHoliday(date) {
      const info = this.getMappedDateInfo(date);
      return info && info.esFeriado ? this.truncateText(info.feriado) : null;
    },
    // Métodos existentes:
    getLabelAusent(date) {
      const info = this.getMappedDateInfo(date);
      return info && info.stAusen ? "red darken-1" : false;
    },

    getLabelTar(date) {
      const info = this.getMappedDateInfo(date);
      return info &&
        (info.stCaidas ||
          info.stTarde ||
          info.stRetant ||
          info.horTrabSum < info.horLabSum)
        ? "yellow darken-1"
        : false;
    },

    getLabels(date) {
      const info = this.getMappedDateInfo(date);
      if (!info) return [];

      // Empezamos con un arreglo vacío de etiquetas.
      const labels = [];

      // 1. Rojo: si tiene ausente.
      const red = this.getLabelAusent(date);
      if (red) {
        labels.push(red);
      }

      // 2. Amarillo: si tiene caídas, tarde, retiro o trabajó menos horas de las requeridas.
      const yellow = this.getLabelTar(date);
      if (yellow) {
        labels.push(yellow);
      }

      // 3. Verde: si tiene horas extras.
      // Nota: en tu lógica original verde se aplicaba solo si no se cumplían las anteriores;
      // pero al decir que no son excluyentes, podemos mostrar ambas si corresponde.
      if (info.horExtSum) {
        labels.push("green darken-1");
      }

      // 4. Si ninguna condición se cumplió, se asigna azul.
      if (labels.length === 0) {
        labels.push("blue darken-1");
      }

      return labels;
    },

    formatDate(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    async prevMonth() {
      this.loading = true;
      this.calendarDate = moment(this.calendarDate)
        .subtract(1, "month")
        .format("YYYY-MM-DD");
      const payload = {
        empId: this.employeeData.empId,
        fecDesde: this.calendarDate,
      };

      await this.$store.dispatch("employees/getMontlyTab", payload);
      this.calendarKey++;
      this.loading = false;
    },
    async nextMonth() {
      this.loading = true;
      this.calendarDate = moment(this.calendarDate)
        .add(1, "month")
        .format("YYYY-MM-DD");
      const payload = {
        empId: this.employeeData.empId,
        fecDesde: this.calendarDate,
      };
      await this.$store.dispatch("employees/getMontlyTab", payload);
      this.calendarKey++;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.legend-box {
  width: 16px;
  height: 16px;
  border-radius: 2px;
}
.day-outside {
  background-color: #f5f5f5;
}
.day-highlight-green {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #83d386;
  height: 150%;
  width: 150%;
  cursor: pointer;
}
.day-highlight-red {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  height: 150%;
  width: 150%;
  cursor: pointer;
}

.custom-chip {
  margin-top: 35px;
  font-size: 0.75rem; /* Tamaño de texto entre small (0.875rem) y x-small (0.625rem) */
  height: 22px; /* Ajusta la altura a un valor intermedio */
  padding: 0 8px; /* Espaciado interno */
  line-height: 20px; /* Asegura que el texto esté centrado */
  border-radius: 12px; /* Mantiene el estilo redondeado */
}
.custom-label {
  margin-top: -20px;
  height: 20px; /* Ajusta la altura a un valor intermedio */
  padding: 0 5px; /* Espaciado interno */
  border-radius: 12px; /* Mantiene el estilo redondeado */
  display: flex;
  align-items: center; /* Centrado vertical */
  justify-content: center; /* Centrado horizontal */
}

.legend-box {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  display: inline-block;
}

.legend-text {
  font-size: 0.95rem; /* Tamaño de texto reducido */
}

.color-bar {
  width: 5px;
  height: 15px;
  border-radius: 4px;
  margin-right: 4px;
}
.color-bar:last-child {
  margin-right: 0;
}
.custom-height {
  height: 93%;
}

@media (max-width: 1920px) {
  /* Para pantallas más pequeñas que Full HD */
  .custom-height {
    height: 89.5%;
  }
}
</style>
